<template>
  <v-row class="d-flex justify-center mt-0">
    <v-col cols="12" sm="10" md="8" class="py-0" :style="$vuetify.breakpoint.mdAndUp ? `height: ${$store.state.height}px` : ''">
      <!-- ARTICULOS -->
      <span class="d-flex align-center font-weight-medium" style="font-size: 20px;">
        <v-icon left>fas fa-shopping-cart</v-icon>
        Artículos
      </span>
      <v-card class="mt-2">
        <v-card-text class="pa-0">
          <div
            v-for="(item, index) in carrito"
            :key="index"
          >
            <v-divider v-if="index != 0"></v-divider>
            <div class="d-flex">
              <v-list-item-avatar
                tile
                size="60"
                class="ml-3"
                color="disabled"
                outlined
              >
                <img v-if="item.base64" :src="`data:image/jpeg;base64,${item.base64}`" />
                <v-icon v-else x-large>fas fa-images</v-icon>
              </v-list-item-avatar>
              <v-row class="ma-0">
                <v-col cols="12" md="7" :class="`d-flex align-center pa-0 ${$vuetify.breakpoint.smAndDown ? 'mt-2' : ''}`">
                  <div style="cursor: default;">
                    <div
                      class="font-weight-medium"
                      style="font-size: 15px; line-height: normal;"
                      :title="item.articulo_nombre.length > ($vuetify.breakpoint.xl ? 80 : 40) ? item.articulo_nombre : ''"
                    >
                      {{ item.articulo_nombre.substring(0, ($vuetify.breakpoint.xl ? 80 : 40)) }}
                      {{ item.articulo_nombre.length > ($vuetify.breakpoint.xl ? 80 : 40) ? '...' : '' }}
                    </div>
                    <div class="d-flex align-center body-2" style="font-size: 12px !important;">
                      Cod. Art.: {{ item.articulo_codigo }}
                      <v-btn
                        class="text-none ml-2"
                        color="primary"
                        x-small
                        text
                        @click="quitarCarrito(item)"
                      >
                        Eliminar
                      </v-btn>
                    </div>
                  </div>
                </v-col>
                <v-col cols="6" sm="8" md="2" :class="`d-flex flex-column align-end justify-center pa-0`">
                  <div class="d-flex align-center">
                    <v-btn
                      color="primary"
                      x-small
                      icon
                      @click="item.cantidad > 0 ? item.cantidad-- : ''"
                    >
                      <v-icon x-small>fas fa-minus</v-icon>
                    </v-btn>
                    <v-text-field
                      v-model="item.cantidad"
                      type="number"
                      class="mx-1"
                      title="Cantidad"
                      style="width: 50px;"
                      hide-details
                      outlined
                      dense
                    ></v-text-field>
                    <v-btn
                      color="primary"
                      x-small
                      icon
                      @click="item.cantidad < item.stock ? item.cantidad++ : ''"
                    >
                      <v-icon x-small>fas fa-plus</v-icon>
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="6" sm="4" md="3" :class="`d-flex justify-end align-center ${$vuetify.breakpoint.smAndDown ? 'py-2' : ''}`">
                  <span class="text-h6" style="font-size: 18px !important;">
                    {{ formatMoney(parseFloat(item.precio_unitario) * parseInt(item.cantidad)) }}
                  </span>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card-text>
      </v-card>
      <div class="d-flex justify-center mt-2" style="width: 100%;">
        <v-btn
          v-if="carrito.length > 0"
          color="info"
          to="/ecommerce"
          small
          text
        >
          Seguir comprando
        </v-btn>
        <div v-else class="text-center">
          <v-alert
            type="info"
            border="left"
            min-width="400"
            text
          >
            No se agregaron artículos
          </v-alert>
          <v-btn
            color="info"
            to="/ecommerce"
          >
            Empezar a comprar
          </v-btn>
        </div>
      </div>
      <!-- ENVIO -->
      <span class="d-flex align-center font-weight-medium mt-4" style="font-size: 20px;">
        <v-icon left>fas fa-truck</v-icon>
        Envío
      </span>
      <v-card class="mt-2">
        <v-card-text :class="`body-1 ${$vuetify.theme.dark ? 'white' : 'secondary'}--text`" class="mb-0">
          <v-radio-group
            v-model="envio"
            class="my-1"
            :column="$vuetify.breakpoint.smAndDown"
            :row="!$vuetify.breakpoint.smAndDown"
            dense
            @change="setEnvio()"
          >
            <v-radio
              label="Retiro en Sucursal"
              :value="1"
            ></v-radio>
            <v-radio
              label="Entrega a coordinar con Ejecutivo"
              :value="2"
            ></v-radio>
          </v-radio-group>
          <v-expand-transition>
            <div v-if="envio == 1">
              {{ direccion_retiro }}
            </div>
          </v-expand-transition>
          <v-expand-transition>
            <div v-if="envio == 2">
              <v-form ref="formEnvio" class="pt-4">
                <v-row>
                  <v-col cols="12" class="py-0">
                    <v-textarea
                      v-model="observaciones_envio"
                      label="Observaciones"
                      rows="3"
                      auto-grow
                      outlined
                      dense
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-form>
            </div>
          </v-expand-transition>
        </v-card-text>
      </v-card>
      <!-- PAGO -->
      <span class="d-flex align-center font-weight-medium mt-4" style="font-size: 20px;">
        <v-icon left>fas fa-hand-holding-usd</v-icon>
        Pagos
      </span>
      <v-row class="py-3">
        <v-col
          v-for="(item, index) in formas_pago"
          :key="index"
          cols="6" sm="4" md="3" xl="2"
        >
          <v-hover v-slot="{ hover }">
            <v-card
              :color="hover ? 'primary' : ''"
              :dark="hover"
              @click="agregarPago(item.tipo)"
            >
              <v-card-title class="pa-2 body-1">
                <v-expand-x-transition>
                  <v-icon v-if="hover" small left>
                    {{ item.icono }}
                  </v-icon>
                </v-expand-x-transition>
                {{ item.nombre }}
              </v-card-title>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
      <v-row class="d-flex justify-center mt-2 mb-4" no-gutters>
        <v-col cols="12" md="10" xl="8">
          <template v-if="pagos.length > 0" >
            <v-card>
              <v-card-text class="pa-0">
                <div
                  v-for="(item, index) in pagos"
                  :key="index"
                >
                </div>
              </v-card-text>
            </v-card>
            Agregar tarjeta...
          </template>
          <div v-else class="d-flex justify-center text-center">
            <v-alert
              type="info"
              border="left"
              min-width="400"
              text
            >
              No se agregaron pagos
            </v-alert>
          </div>
        </v-col>
      </v-row>
      <v-divider v-if="$vuetify.breakpoint.smAndDown" class="pb-4"></v-divider>
    </v-col>
    <v-col cols="12" sm="8" md="4" class="py-0" style="position: sticky; top: 60px; align-self: flex-start; height: 100%;">
      <span class="d-flex align-center font-weight-medium" style="font-size: 20px;">
        <v-icon left>fas fa-clipboard-list</v-icon>
        Resumen
      </span>
      <v-card class="mt-2">
        <v-card-text class="body-1 pa-3">
          <v-row no-gutters>
            <v-col cols="6">
              Subotal
            </v-col>
            <v-col cols="6" class="d-flex justify-end">
              {{ formatMoney(carrito.reduce((sum, carr) => sum + (parseInt(carr.cantidad) * parseFloat(carr.precio_unitario)), 0)) }}
            </v-col>
          </v-row>
          <v-row v-if="saldo < 0" no-gutters>
            <v-col cols="7" class="d-flex align-center">
              Adeudado Cta. Cte.
              <v-btn
                color="primary"
                class="ml-1"
                x-small
                icon
              >
                <v-icon x-small>fas fa-trash</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="5" class="d-flex justify-end">
              {{ formatMoney(saldo * -1) }}
            </v-col>
          </v-row>
          <v-divider class="py-1"></v-divider>
          <div class="d-flex body-1 font-weight-bold">
            Total a Pagar
            <v-spacer></v-spacer>
            <span class="info--text">
              {{ formatMoney(carrito.reduce((sum, carr) => sum + (parseInt(carr.cantidad) * parseFloat(carr.precio_unitario)), 0) + (saldo * -1)) }}
            </span>
          </div>
        </v-card-text>
      </v-card>
      <v-card class="mt-4">
        <v-card-text class="body-1">
          <v-row no-gutters>
            <v-col cols="6" class="d-flex align-center">
              <v-icon color="purple" left small>fas fa-wallet</v-icon>
              Saldo Cta. Cte.
            </v-col>
            <v-col cols="6" class="d-flex justify-end">
              {{ formatMoney(saldo > 0 ? saldo : 0) }}
            </v-col>
          </v-row>
          <v-row v-if="limite_credito > 0" no-gutters>
            <v-col cols="6" class="d-flex align-center">
              <v-icon color="pink" left small>fas fa-money-check-alt</v-icon>
              Crédito
              <span class="body-2 ml-2" style="font-size: 12px !important;">
              (límite {{ formatMoneyRound(limite_credito) }})
              </span>
            </v-col>
            <v-col cols="6" class="d-flex justify-end">
              <text-field-money
                v-model="monto_credito"
                v-bind:properties="{
                  prefix: '$',
                  hideDetails: true
                }"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6" class="d-flex align-center">
              <v-icon color="success" left small>fas fa-money-bill-alt</v-icon>
              Transferencia
            </v-col>
            <v-col cols="6" class="d-flex justify-end">
              <text-field-money
                v-model="monto_transf"
                v-bind:properties="{
                  prefix: '$',
                  hideDetails: true
                }"
              />
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="6" class="d-flex align-center">
              <v-icon color="indigo" left small>fas fa-credit-card</v-icon>
              P. con Tarjeta
            </v-col>
            <v-col cols="6" class="d-flex justify-end">
              {{ formatMoney(monto_tarjeta) }}
            </v-col>
          </v-row>
          <v-divider class="py-1"></v-divider>
          <div class="d-flex body-1 font-weight-bold">
            Total
            <v-spacer></v-spacer>
            <span class="info--text">
              {{ formatMoney(total) }}
            </span>
          </div>
        </v-card-text>
      </v-card>
      <v-expand-transition>
        <v-card v-if="true" class="mt-4">
          <v-card-text>
            {{ texto_trans }}
          </v-card-text>
        </v-card>
      </v-expand-transition>
    </v-col>
    <!-- componentes -->
    <Transferencia
      v-model="dialog_trans"
    />
    <Tarjeta
      v-model="dialog_tarjeta"
    />
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import { format_money, format_money_round } from '../../util/utils'
import TextFieldMoney from '../../components/util/TextFieldMoney.vue'
import Transferencia from '../../components/ecommerce/Transferencia.vue'
import Tarjeta from '../../components/ecommerce/Tarjeta.vue'

export default {
  data () {
    return {
      formatMoney: format_money,
      formatMoneyRound: format_money_round,
      dialog_tarjeta: false,
      dialog_trans: false,
      envio: null,
      saldo: 0,
      total: 0,
      monto_transf: 0,
      monto_tarjeta: 0,
      monto_credito: 0,
      limite_credito: 0,
      provincias: [],
      localidades: [],
      locales_user: [],
      pagos: [],
      direccion_retiro: null,
      observaciones_envio: null,
      texto_trans: 'Los pagos con transferencia pueden tardar en impactar hasta 24hs si se realizan antes de las 15hs y hasta 48hs si se realizan despúes de las 15hs.',
      formas_pago: [
        { nombre: 'Tarjeta', icono: 'fas fa-credit-card', tipo: 'tarjeta' },
        { nombre: 'Transferencia', icono: 'fas fa-money-bill-alt', tipo: 'trans' }
      ],
      rules: {
        required: value => !!value || 'Campo requerido'
      }
    }
  },
  async created () {
    this.$store.state.loading = true
    let result_c = await this.$store.dispatch('mayoristaCobranzas/obtenerClientesMayoristas', {
      ejecutivo_codigo: 9323,
      codigo: 50006,
      nombre: '',
      nroDocumento: 0
    })
    let result_s = await this.$store.dispatch('ventasMay/saldo_gestor', 50006)
    this.$store.state.loading = false

    if (result_c.resultado == 1) {
      const datos = result_c.clientes[0]
      this.limite_credito = datos.limite_credito
    } else {
      this.$store.dispatch('show_snackbar', {
        text: result_c.message,
        color: 'error'
      })
      return
    }

    if (result_s.exito == 1) {
      this.saldo = result_s.saldo
    } else {
      this.$store.dispatch('show_snackbar', {
        text: result_s.message,
        color: 'error'
      })
    }

  },
  computed: {
    ...mapState(['carrito'])
  },
  components: {
    TextFieldMoney,
    Transferencia,
    Tarjeta
  },
  watch: {
  },
  methods: {
    agregarPago (tipo) {
      switch (tipo) {
        case 'tarjeta':
          this.dialog_tarjeta = true
          break
        case 'trans':
          this.dialog_trans = true
          break
      }
    },
    setEnvio () {
      this.direccion_retiro = 'Av. Belgrano 839 - CP4400, Salta, Salta'
      this.observaciones_envio = null
    },
    quitarCarrito (item) {
      const index = this.carrito.indexOf(item)
      this.carrito.splice(index, 1)
    }
  }
}
</script>